<template>
    <my-table :data="list" v-loading="loadingController">
        <el-table-column label="资料名称">
            <template slot-scope="scope">
                <template v-if="!scope.row.editable">
                    {{scope.row.fname}}
                </template>
                <template v-else>
                    <el-input v-model="form.filename" placeholder="名称"></el-input>
                </template>
            </template>
        </el-table-column>
        <el-table-column label="说明">
            <template slot-scope="scope">
                <template v-if="!scope.row.editable">
                    {{scope.row.detail}}
                </template>
                <template v-else>
                    <el-input v-model="form.detail" placeholder="说明"></el-input>
                </template>
            </template>
        </el-table-column>
        <el-table-column label="必传">
            <template slot-scope="scope">
                <template v-if="!scope.row.editable">
                    {{scope.row.necessary}}
                </template>
                <template v-else>
                    <el-checkbox v-model="form.necessary">是</el-checkbox>
                </template>
            </template>
        </el-table-column>
        <el-table-column label="操作" v-if="!readonly">
            <template slot-scope="scope">
                <template v-if="!scope.row.editable">
                    <my-btn type="del" @click="delHandler(scope.row)"></my-btn>
                </template>
                <template v-else>
                    <el-button type="text" icon="el-icon-plus" @click="addHandler">添加</el-button>
                </template>
            </template>
        </el-table-column>
    </my-table>
</template>

<script>
export default {
    props: {
        value: {
            type: Array,
            default: () => []
        },
        bmzlguid: {
            type: String,
            default: ''
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        form: {},
        loadingController: false
    }),
    computed: {
        list: {
            get() {
                if(this.value.list){
                    var value = clone(this.value.list);
                }else{
                    var value = clone(this.value);
                }

                if(!this.readonly) {
                    value.push({editable: true});
                };
                return value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    },
    methods: {
        formInit() {
            this.form = {
                filename: '',
                detail: '',
                necessary: true,
            };
        },
        listInit(list) {
            this.list = list;
        },
        addHandler() {
            if(!this.form.filename || !this.form.detail) {
                ShowMsg('请输入报名资料！')
                return;
            };
            this.loadingController = true;

            this.form.bmzlguid = this.bmzlguid;

            this.$ajax({
                type: 'post',
                url: `${this.getGetters('ageUrl')}/revision/FangAn/BiaoDuan/addzl.json`,
                data: this.form,
                callback: (data, res) => {
                    this.listInit(data.list);
                    this.formInit();
                },
                complete: () => {
                    this.loadingController = false;
                }
            });
        },
        delHandler(row) {
            this.loadingController = true;

            this.$ajax({
                type: 'post',
                url: `${this.getGetters('ageUrl')}/revision/FangAn/BiaoDuan/delzl.json`,
                data: {
                    filename: row.fname,
                    id: row.id,
                    bmzlguid: this.bmzlguid
                },
                callback: (data, res) => {
                    this.listInit(data);
                    this.formInit();
                },
                complete: () => {
                    this.loadingController = false;
                }
            });
        }
    },
    created() {
        this.formInit();
    }
}
</script>

<style scoped lang="scss">

</style>
